<template>
  <div class="k-search-input">
    <input type="text" :value="value" @input="$emit('input', $event.target.value)" :placeholder="placeholder">
    <div class="search-icon">
      <KkIcon name="ic_search_line_semiblod" style="color: var(--kk-color-text-medium)" />
    </div>
  </div>
</template>

<script>
import { KkIcon } from '@kkday/web-design-system'

export default {
  components: {
    KkIcon
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.k-search-input {
  border-radius: var(--kk-radius-md);
  border: 1px solid var(--kk-color-border-light);
  background: #FFF;
  padding: 14px var(--kk-spacing-4);
  height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  input {
    border: none;
    outline: none;
    width: 100%;
    padding-right: var(--kk-spacing-3);
    &::placeholder {
      color: var(--kk-color-text-light);
    }
  }
  .search-icon {
    margin-left: var(--kk-spacing-3);
  }
}
</style>
